import { BaseRecord } from '../BaseRecord';

export type Record = BaseRecord & OwnRecord;

export type OwnRecord = {
    color?: CarnivalTreasureColor;
    resultIndex: number;
    resultPoint?: number;
    multiples?: boolean;
    payout?: number;
};

export enum CarnivalTreasureColor {
    BLUE,
    GREEN,
    YELLOW,
    PURPLE,
    ORANGE,
    RED,
    BONUS_2X,
    BONUS_10X,
}
